import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { BaseApiResponse, SessionResponse } from '@/types/api/api-v2';
export default async function getSession() {
  try {
    const {
      data: { data },
    } = await spiritoryWebApi.get<BaseApiResponse<SessionResponse>>('/auth/session');
    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
}
